import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PaymentElementComponent } from "./components/payment-element/payment-element.component";
import { SelectPaymentMethodsComponent } from "./components/select-payment-methods/select-payment-methods.component";
import { FormsModule as RubblFormsModule } from "../forms/forms.module";
import { CreatePaymentMethodFormComponent } from "./payments/components/create-payment-method-form/create-payment-method-form.component";

@NgModule({
  declarations: [PaymentElementComponent, SelectPaymentMethodsComponent, CreatePaymentMethodFormComponent],
  imports: [CommonModule, RubblFormsModule],
  exports: [PaymentElementComponent, SelectPaymentMethodsComponent, CreatePaymentMethodFormComponent],
})
export class BillingModule {}
